/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MealTypeView } from './meal-type-view';
import {
    MealTypeViewFromJSON,
    MealTypeViewFromJSONTyped,
    MealTypeViewToJSON,
    MealTypeViewToJSONTyped,
} from './meal-type-view';
import type { BookingCancellationDto } from './booking-cancellation-dto';
import {
    BookingCancellationDtoFromJSON,
    BookingCancellationDtoFromJSONTyped,
    BookingCancellationDtoToJSON,
    BookingCancellationDtoToJSONTyped,
} from './booking-cancellation-dto';

/**
 * 
 * @export
 * @interface TariffInfoDto
 */
export interface TariffInfoDto {
    /**
     * Идентификатор тарифа
     * @type {string}
     * @memberof TariffInfoDto
     */
    id: string;
    /**
     * 
     * @type {MealTypeView}
     * @memberof TariffInfoDto
     */
    mealType: MealTypeView;
    /**
     * Цена за тариф
     * @type {number}
     * @memberof TariffInfoDto
     */
    price: number;
    /**
     * Размещение
     * @type {string}
     * @memberof TariffInfoDto
     */
    fullPlacementsName: string | null;
    /**
     * Checksum
     * @type {string}
     * @memberof TariffInfoDto
     */
    checksum: string | null;
    /**
     * 
     * @type {BookingCancellationDto}
     * @memberof TariffInfoDto
     */
    bookingCancellation: BookingCancellationDto;
}

/**
 * Check if a given object implements the TariffInfoDto interface.
 */
export function instanceOfTariffInfoDto(value: object): value is TariffInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('mealType' in value) || value['mealType'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('fullPlacementsName' in value) || value['fullPlacementsName'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    if (!('bookingCancellation' in value) || value['bookingCancellation'] === undefined) return false;
    return true;
}

export function TariffInfoDtoFromJSON(json: any): TariffInfoDto {
    return TariffInfoDtoFromJSONTyped(json, false);
}

export function TariffInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TariffInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mealType': MealTypeViewFromJSON(json['mealType']),
        'price': json['price'],
        'fullPlacementsName': json['fullPlacementsName'],
        'checksum': json['checksum'],
        'bookingCancellation': BookingCancellationDtoFromJSON(json['bookingCancellation']),
    };
}

  export function TariffInfoDtoToJSON(json: any): TariffInfoDto {
      return TariffInfoDtoToJSONTyped(json, false);
  }

  export function TariffInfoDtoToJSONTyped(value?: TariffInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mealType': MealTypeViewToJSON(value['mealType']),
        'price': value['price'],
        'fullPlacementsName': value['fullPlacementsName'],
        'checksum': value['checksum'],
        'bookingCancellation': BookingCancellationDtoToJSON(value['bookingCancellation']),
    };
}

